export default "__VITE_ASSET__B9pU9cr6__"